class CollectionWithBannerScroller extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[ref="scroller"]');
    this.prevButton = this.querySelector('[data-nav="prev"]');
    this.nextButton = this.querySelector('[data-nav="next"]');

    if (!this.track) return;

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scrollByCards(-1));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scrollByCards(1));
    }

    this.track.addEventListener('scroll', () => this.updateNavState(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateNavState());
    this.resizeObserver.observe(this.track);

    this.updateNavState();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  scrollByCards(direction) {
    const card = this.track.querySelector('[data-card]');
    if (!card) return;

    const cardWidth = card.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap || '0');
    const visibleCount = Math.max(1, Math.floor(this.track.clientWidth / (cardWidth + gap)));
    const distance = (cardWidth + gap) * visibleCount * direction;

    this.track.scrollBy({ left: distance, behavior: 'smooth' });
  }

  updateNavState() {
    if (!this.prevButton && !this.nextButton) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const maxScroll = scrollWidth - clientWidth;
    const atStart = scrollLeft <= 4;
    const atEnd = scrollLeft >= maxScroll - 4;

    if (this.prevButton) this.prevButton.disabled = atStart;
    if (this.nextButton) this.nextButton.disabled = atEnd || maxScroll <= 0;
  }
}

if (!customElements.get('collection-with-banner-scroller')) {
  customElements.define('collection-with-banner-scroller', CollectionWithBannerScroller);
}